/** Affichage stock / quantité dispo : entier sans séparateur de milliers ni décimales (ex. 1333, pas 1,333). */
export function formatPlainStockQuantity(value: number | string | null | undefined): string {
    if (value == null || value === '') {
        return '0';
    }
    const n = Number(value);
    if (!Number.isFinite(n)) {
        return '0';
    }
    return String(Math.trunc(n));
}
